import { useContext, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';

// Components
import MapleTypography from 'Components/ds/MapleTypography';
import MapleIcon from 'Components/ds/MapleIcon';

// Hooks
import useBreakpoint from 'Hooks/useBreakpoint';
import { useAnalytics } from 'Hooks/useAnalytics';

// Contexts
import { DataContext } from 'Context/Data';

// Constants
import { PERCENTAGE_UI_DECIMALS } from 'Constants/tokens';
import { LEND_ROUTE } from 'Constants/navigation';

// Styles
const wrapper = {
  background: theme => theme.palette.circleBlue.main,
  borderBottom: theme => `0.5px solid ${theme.palette.stroke.sub}`,
  py: 1.5,
  px: 2.5,
  position: 'relative',
};
const text = {
  color: theme => theme.palette.text.white,
  a: {
    color: theme => theme.palette.text.white,
    svg: {
      transform: 'translate(3px, 3px)',
    },
  },
};
const textLink = {
  textDecoration: 'underline',
  color: theme => theme.palette.text.white,
};

const AppBanner = () => {
  const { isDesktopDevice } = useBreakpoint();
  const { analytics } = useAnalytics();
  const { pools } = useContext(DataContext);

  const usdcApy = useMemo(() => {
    const usdcPool = pools.find(pool => pool.asset.symbol.toLowerCase() === 'usdc');
    const value = +(usdcPool?.poolMeta?.targetYield || 0).toFixed(PERCENTAGE_UI_DECIMALS);

    return value;
  }, [pools]);

  const handleOnClick = () => {
    analytics?.track('Syrup - Home - Top Banner - Circle - Click');
  };

  if (isDesktopDevice)
    return (
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
        sx={wrapper}
        spacing={2}
        onClick={handleOnClick}
      >
        <MapleTypography variant='label' size='xSmall' color='text.white'>
          Earn {usdcApy}% APY with USDC and win up to 300,000 USDC.
        </MapleTypography>
        <Link to={`${LEND_ROUTE}?asset=usdc&lendInputFocused=true`}>
          <MapleTypography variant='paragraph' size='xSmall' sx={textLink}>
            Deposit Now
          </MapleTypography>
        </Link>
      </Stack>
    );

  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between' sx={wrapper} spacing={1}>
      <MapleTypography variant='label' size='xSmall' color='text.white' sx={text}>
        Earn {usdcApy}% APY with USDC and win up to 300k USDC.
      </MapleTypography>
      <Link to={`${LEND_ROUTE}?asset=usdc&lendInputFocused=true`}>
        <Stack direction='row' alignItems='center' justifyContent='center'>
          <MapleIcon icon='arrowRight' size={16} color='text.white' />
        </Stack>
      </Link>
    </Stack>
  );
};

export default AppBanner;
